module.exports = __webpack_public_path__ + "media/images/courseDefault2-d64427fe764f8aa55ba2b0d59d889864.png";